var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-item"},[_c('div',{staticClass:"grid-block bio-block"},[_vm._v(_vm._s(_vm._f("truncate")(_vm.bioText,100)))])])}
var staticRenderFns = []

export { render, staticRenderFns }